import React from 'react';
import PropTypes from 'prop-types';

const PdxNavPanel = ({
  cols,
  left,
  right,
  width,
  split,
  hasBottomCap, // if the bottom element goes flush to the bottom, don't add padding
  children
}) => {
  const colWidth = width || 260;
  const splitColWidth = 265;
  const position = {};
  position.width = split ? `${cols * splitColWidth}px` : `${cols * colWidth}px`;
  if (left > 0) position.left = `${left}px`;
  else if (right > 0) { position.right = `${right}px`; }

  return (
    <div className={`pdx-nav-panel${split ? ' split' : ''}${hasBottomCap ? ' pb-0' : ''}`} style={position}>
      {children}
    </div>
  );
};

PdxNavPanel.defaultProps = {
  cols: 1,
  left: 0,
  right: 0,
  width: undefined,
  split: false,
  hasBottomCap: false
};

PdxNavPanel.propTypes = {
  cols: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  width: PropTypes.number,
  split: PropTypes.bool,
  hasBottomCap: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]).isRequired
};

export default PdxNavPanel;
